// סימניה אחת לכל סוג שיעור: { date: 'YYYY-MM-DD', index: מיקום האלמנט בתוך תוכן השיעור }
const KEY = 'tfilulari/bookmarks';

export function getBookmark(type) {
  try { return JSON.parse(localStorage.getItem(KEY))?.[type] || null; }
  catch (e) { return null; }
}

export function setBookmark(type, bookmark) {
  let all;
  try { all = JSON.parse(localStorage.getItem(KEY)) || {}; }
  catch (e) { all = {}; }
  all[type] = bookmark;
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function removeBookmark(type) {
  let all;
  try { all = JSON.parse(localStorage.getItem(KEY)) || {}; }
  catch (e) { all = {}; }
  delete all[type];
  localStorage.setItem(KEY, JSON.stringify(all));
}
